import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import "./Blog.css";
import { ADMIN_ID } from "./Constant";

const CommentSection = ({ slug }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [visibleCount, setVisibleCount] = useState(2);
  const navigate = useNavigate();
  const login = JSON.parse(localStorage.getItem("login")) || null;
const url=process.env.REACT_APP_LINK
  useEffect(() => {
    if (!slug) return;

    fetch(`${url}/api/comments/slug/${slug}`)
      .then((res) => res.json())
      .then((data) => setComments(Array.isArray(data) ? data : []))
      .catch((err) => console.error("❌ Error fetching comments:", err));
  }, [slug]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    try {
      const res = await fetch(`${url}/api/comments`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          slug,
          content: newComment,
          author: login?.full_name || login?.email || "Anonymous",
          AdminId: ADMIN_ID,
        }),
      });

      if (!res.ok) {
        console.error("❌ Server error:", await res.text());
        return;
      }

      const saved = await res.json();
      setComments([saved, ...comments]);
      setNewComment("");
      setVisibleCount((prev) => prev + 1);
    } catch (err) {
      console.error("❌ Failed to post comment:", err.message);
    }
  };

  return (
    <div className="comment-section-premium">
      <h3 className="comment-section-heading">
        <MessageCircle size={20} className="icon" /> {comments.length} Comment{comments.length !== 1 && 's'}
      </h3>

      <form onSubmit={handleSubmit} className="comment-form">
        <textarea
          rows="4"
          placeholder="Share your thoughts..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          className="comment-input"
        />
        <button type="submit" className="comment-submit-btn">
          Post Comment
        </button>
      </form>

      <div className="comment-list">
        {comments.slice(0, visibleCount).map((comment, index) => (
          <div key={index} className="comment-card">
            <div className="comment-header">
              <strong className="comment-author">{comment.author || "Anonymous"}</strong>
              <span className="comment-date">{new Date(comment.createdAt).toLocaleString()}</span>
            </div>
            <p className="comment-content">{comment.content}</p>
          </div>
        ))}
      </div>

      {comments.length > visibleCount && (
        <button
          onClick={() => navigate(`/blogs/${slug}/comments`)}
          className="view-all-comments-btn"
        >
          View All Comments
        </button>
      )}
    </div>
  );
};

export default CommentSection;